import { memo } from "react";
import { Modal, Button, Space, Spin, Alert, Tooltip, Typography } from "antd";
import { CheckCircleOutlined, CloseCircleOutlined, InfoCircleOutlined } from "@ant-design/icons";
import styles from "../styles/UberSyncUI.module.css";

const { Text } = Typography;

const SyncProgressModal = ({ visible, loading, results, onClose }) => {
  return (
    <Modal
      title="Progreso de Sincronización a Uber Eats"
      visible={visible}
      onCancel={loading ? null : onClose}
      footer={[
        <Button key="close" type="primary" disabled={loading} onClick={onClose}>
          Cerrar
        </Button>
      ]}
      closable={!loading}
      maskClosable={false}
      destroyOnClose
      width={500}
    >
      <div style={{ marginBottom: 16 }}>
        {loading ? (
          <Space>
            <Spin size="small" />
            <Text strong>Sincronizando menús con Uber Eats. Por favor, no cierre esta ventana...</Text>
          </Space>
        ) : (
          <Alert
            message="Sincronización Finalizada"
            description="Se completó el proceso de envío de menús. A continuación se detallan los resultados por sucursal."
            type="info"
            showIcon
          />
        )}
      </div>

      <div className={styles.logsList}>
        {results.map((res) => {
          const isSuccess = res.status === "success";
          const isPending = res.status === "pending";
          const isSyncing = res.status === "syncing";

          return (
            <div key={res.branchId} className={styles.logItem}>
              <div>
                <div className={styles.logStoreName}>{res.name.toUpperCase()}</div>
                <div className={styles.logStoreId}>ID Sucursal: {res.branchId}</div>
              </div>
              <div className={styles.logStatusArea}>
                {isSyncing && <Spin size="small" />}
                {isSuccess && <CheckCircleOutlined className={styles.statusSuccess} />}
                {!isSuccess && !isPending && !isSyncing && <CloseCircleOutlined className={styles.statusError} />}
                
                <span
                  className={`${styles.logStatusText} ${
                    isSuccess
                      ? styles.statusSuccess
                      : isSyncing
                      ? styles.statusSyncing
                      : isPending
                      ? styles.statusPending
                      : styles.statusError
                  }`}
                >
                  {isSyncing ? "Enviando..." : isPending ? "En Cola" : isSuccess ? "Éxito" : "Error"}
                </span>

                {!isSuccess && !isPending && !isSyncing && res.message && (
                  <Tooltip title={res.message}>
                    <InfoCircleOutlined className={styles.infoIconError} />
                  </Tooltip>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </Modal>
  );
};

export default memo(SyncProgressModal);
